import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'

import {
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    Deployment,
} from './Deployment.types'

const config: SkyNetTableConfig<keyof Deployment> = {
    name: 'DeploymentsTable',
    tabs: [{
        name: 'All',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'deploymentName',
                labelKey: 'Deployment.deploymentName',
                reduced: true,
                minWidth: '300px',
            },
            {
                name: 'createdOn',
                labelKey: 'Deployment.createdOn',
                width: '300px',
                componentName: 'DateTimeCell',
            },
            {
                name: 'createdBy',
                labelKey: 'Deployment.createdBy',
                width: '300px',
            },
        ],
    }],
}

export default config
